import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import ScrollAnimations from './components/ScrollAnimations';
import Home from "./pages/Home";
import AllCourses from "./pages/AllCourses";
import Team from "./pages/Team";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollAnimations />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courses" element={<AllCourses />} />
        <Route path="/team" element={<Team />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;